export interface VersionInfo {
  readonly prNumber: string | null;
  readonly gitSha: string | null;
  readonly isProduction: boolean;
}

const SHORT_SHA_LENGTH = 7;

function normalize(value: string | undefined): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed.length === 0 ? null : trimmed;
}

export function readVersionInfo(): VersionInfo {
  return {
    prNumber: normalize(import.meta.env.VITE_PR_NUMBER),
    gitSha: normalize(import.meta.env.VITE_GIT_SHA),
    isProduction: import.meta.env.PROD,
  };
}

export function formatVersionLabel(info: VersionInfo): string {
  if (info.prNumber !== null) return `PR #${info.prNumber}`;
  if (info.gitSha !== null) return info.gitSha.slice(0, SHORT_SHA_LENGTH);
  return info.isProduction ? "release" : "dev";
}
